import tableLanguages from './tableLanguages';
import routes from '../routes/route';

export default {
  title: 'Language Management',
  attributeName: 'languages',
  getURL: 'languages',
  createURL: 'languages',
  refreshURL: 'languages',
  updateURL: 'languages/bulk',
  removeURL: 'languages',
  sessionParams: [],
  noArea: true,
  tableConfig: tableLanguages,
  sessionWebsocketParams: [],
  websocketEventChanel: 'languages',
  websocketItem: 'languages',
  autoUpdate: true,
};